import React from 'react';

const NaturalFollowUp = ({ message, hasData, hasCharts, tableAlreadyShown }) => {
  if (!message && !hasData) return null;

  const suggestions = [];
  if (hasData) {
    if (!tableAlreadyShown) {
      suggestions.push("show me the table");
    }
    if (hasCharts) {
      suggestions.push("create some charts");
    }
    suggestions.push("export this data");
  }

  const suggestionText = suggestions.length > 0 
    ? `You can say "${suggestions.join('", "')}" or ask me something else!`
    : "";

  return (
    <div style={{
      backgroundColor: '#f8fafc',
      borderLeft: '3px solid #4F7CFF',
      borderRadius: '0 8px 8px 0',
      padding: '1rem 1.25rem',
      marginTop: '1rem',
      fontSize: '0.9rem',
      color: '#475569',
      fontStyle: 'italic'
    }}>
      {message && (
        <div style={{ marginBottom: suggestionText ? '0.5rem' : '0' }}>
          {message}
        </div>
      )}
      {suggestionText && (
        <div style={{ color: '#64748b', fontSize: '0.85rem' }}>
          {suggestionText}
        </div>
      )}
    </div>
  );
};

export default NaturalFollowUp;